<i-title styleClass="w-100" [text]="'modals.quickArchiving' | translate" [buttons]="titleButtons" level="1"></i-title>

<section class="form mb-4 p-4" [formGroup]="form">
  <div class="row">
    <div class="col-md-6 mb-3">
      <label class="w-100">
        <span class="super-compos-label-input">{{ 'modals.archiveBox' | translate }}</span>
        <i-input
          [type]="'text'"
          [iInput]="{ placeholder: 'modals.archiveBoxNumber' | translate }"
          [control]="form.get('boiteArchivage')"
          [showError]="false"
          styleClass="d-block w-100"></i-input>
      </label>
    </div>
    <div class="col-md-6 mb-3">
      <label class="w-100">
        <span class="super-compos-label-input">{{ 'modals.mailIdentifier' | translate }}</span>
        <i-input
          [type]="'number'"
          [iInput]="{ placeholder: 'modals.mailIdentifier' | translate }"
          [control]="form.get('courrierId')"
          styleClass="d-block w-100">
        </i-input>
      </label>
    </div>
  </div>
</section>
